/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : Header.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Header component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 26, 2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Header, Icon, Grid } from "@scuf/common";
import { selectToken, selectUserInfo } from "stores/AuthStore";
import { useAuth } from "components/Auth";
import { appConfig } from "shared/utils";
import { LABEL_TEXT, HEADER_URL } from "./constants";
import aeroImage from "./aero.png";
import asdsImage from "./asds.png";
import "./Header.scss";

export const HeaderComponent: FC = () => {
  const token = useSelector(selectToken);
  const userInfo = useSelector(selectUserInfo);
  const { logout } = useAuth();

  const onLogoutHandler = () => {
    if (logout !== undefined) {
      logout(token);
    }
  };

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column className="col-no-padding">
          <Header
            className="header-css"
            responsive={true}
            menu={false}
            isForge={false}
            title={LABEL_TEXT.title}
          >
            {userInfo && (
              <>
                <Header.AppLauncher>
                  <Header.AppLauncher.Item
                    appName={LABEL_TEXT.asdsAppName}
                    imageUrl={asdsImage}
                    iconRoot="aero"
                    onClick={() =>
                      (window.location.href = appConfig.asds_endpoint)
                    }
                  />
                  <Header.AppLauncher.Item
                    appName={LABEL_TEXT.homeAppName}
                    imageUrl={aeroImage}
                    iconRoot="aero"
                    onClick={() =>
                      (window.location.href = HEADER_URL.aerospaceHome)
                    }
                  />
                </Header.AppLauncher>
                <Header.UserProfile
                  firstName={userInfo.given_name}
                  lastName={userInfo.family_name}
                  // imageUrl={userInfo.avatar}
                >
                  <Header.UserProfile.Item className="user-profile-item-main">{`${LABEL_TEXT.welcome} ${userInfo.name}`}</Header.UserProfile.Item>
                  <Header.UserProfile.Item
                    className="user-profile-item-link"
                    href={HEADER_URL.myAccount}
                    target="_blank"
                    rel="noopener"
                  >
                    <Icon
                      className="user-profile-item-icon"
                      name="settings"
                      root="common"
                    />
                    {LABEL_TEXT.settings}
                  </Header.UserProfile.Item>
                  <Header.UserProfile.Item
                    className="user-profile-item-link"
                    href={HEADER_URL.myPassword}
                    target="_blank"
                    rel="noopener"
                  >
                    <Icon
                      className="user-profile-item-icon"
                      name="lock"
                      root="common"
                    />
                    {LABEL_TEXT.lock}
                  </Header.UserProfile.Item>
                  <Header.UserProfile.Item
                    className="user-profile-item-link"
                    onClick={onLogoutHandler}
                    data-testid="fh-logout-id"
                  >
                    <Icon
                      className="user-profile-item-icon"
                      name="exit"
                      root="common"
                    />
                    {LABEL_TEXT.exit}
                  </Header.UserProfile.Item>
                </Header.UserProfile>
              </>
            )}
          </Header>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};
